import * as types from '../actions/types';

const initialState = {
    page:1,
    sortColumn: null,
    sortDirection: null,
}

export default function orderListSortReducer(state = initialState, action = null) {
    switch (action.type) {
        case types.ORDER_LIST_SORT:
            return { ...state, sortColumn: action.payload.column, sortDirection: action.payload.direction };
        default: return state
    }
}